import React from "react";
import BaseComponent from "../../common/BaseComponent";
import NormalModal from "../modal";
import { ExpendTextArea, ExpendTextAreaByProps } from "../input";
import "./index.scss";

export default class ReturnReasonDetailModal extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      isModalOpen: false,
      closable: true,
      okText: "",
      cancelText: "",
      modalTitle: "Reason for Return",
    };
  }

  handleChildContent = () => {
    if (!this.state.isModalOpen) return;

    const { isTable, inputProps, isFileTableShow, isClientPathShow } = this.props;

    if (!isTable) {
      return <ExpendTextAreaByProps {...inputProps} isFileTableShow={isFileTableShow} />;
    }
    return <ExpendTextArea {...inputProps} isClientPathShow={isClientPathShow} />;
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.isReasonDetailModalOpen !== this.props.isReasonDetailModalOpen) {
      this.setState({
        isModalOpen: this.props.isReasonDetailModalOpen,
      });
    }
  }

  render() {
    const { isModalOpen, closable, okText, cancelText, modalTitle } = this.state;

    return (
      <NormalModal
        testid={this.props.testid || "return-reason-detail-modal"}
        isModalOpen={isModalOpen}
        closable={closable}
        okText={okText}
        cancelText={cancelText}
        title={modalTitle}
        width={700}
        centered
        destroyOnClose
        className="returnReasonDetailModal"
        childContent={this.handleChildContent()}
        handleCancel={() => this.props.handleReturnReasonDetail()}
        footer={null}
      />
    );
  }
}
